import { Table, TableWrapper } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { mostrarErro } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { AuthContext } from '@4beefopag/4bee-fopag-core/dist/services/hooks';
import { message } from 'antd';
import fileDownload from 'js-file-download';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { downloadApdataReportById } from '../../../services/repository/payrollRepository';
import { downloadFile, getPublicUrlsByRequisicao } from '../../../services/upload';
import { sleep } from '../../../services/util/async';
import PayrollTableRow from './PayrollTableRow';
import { HeaderWithSort } from '../../atoms/Table';

const CenterColumn = styled.th`
  text-align: center;
`;

const TableHeader = styled.thead`
  text-align: left;
`;

const TableBody = styled.tbody`
  :hover {
    background: #f5f5f5;
  }
`;

function PayrollTable({
  payrolls,
  onEditClick,
  onTransmitClick,
  onEarlyPayment,
  onChangeOrder,
  orderBy,
  canShowApdataInfo,
}) {
  const { isAdmin: checkUserIsAdmin } = useContext(AuthContext);
  const isAdmin = checkUserIsAdmin();

  const clickOrderBy = (key, value) => {
    onChangeOrder({ [key]: value });
  };

  const downloadFileByType = async (requisicaoSelected, type) => {
    try {
      const hide = message.loading('Seu download está sendo preparado');
      if (type === 'planilha') {
        const { id, nomeFolha } = requisicaoSelected;
        const relatorioOp = await downloadApdataReportById(id);
        fileDownload(relatorioOp, `${nomeFolha}-${id}.xls`);
      } else if (type === 'anexos') {
        const { data: fileList } = await getPublicUrlsByRequisicao(requisicaoSelected.id);
        let count = 0;
        for (const { nome, link } of fileList) {
          await downloadFile(nome, link);

          count += 1;
          /**
           * Implementação realizada para permitir o download de mais de 10 arquivos,
           * uma vez que o navegador impõe um limite de 10 downloads por segundo:
           * https://stackoverflow.com/questions/53560991/automatic-file-downloads-limited-to-10-files-on-chrome-browser
           */
          if (count === 10) {
            await sleep(1100);
            count = 0;
          }
        }
      }
      hide();
    } catch (e) {
      mostrarErro(e);
    }
  };

  return (
    <TableWrapper>
      <Table
        widthInput="112px"
        background="#f6f7f9"
        borderBottomTh="1px solid #e8e8e8"
        borderBottomTd="1px solid #e8e8e8"
        style={{ width: '100%' }}
      >
        <TableHeader>
          <tr>
            <th>Data da Operação</th>
            <th>N° Requisição</th>
            {canShowApdataInfo && <th>Log Transação</th>}
            <th>Folha</th>
            <th>Operação</th>
            <th>Vencimento Previsto da Fatura</th>
            <th>Vencimento da Fatura</th>
            <th>Pgto. Cooperado</th>
            <HeaderWithSort
              orderType={orderBy.paymentDateAdjustedByManager}
              clickOnOrder={(orderType) => clickOrderBy('paymentDateAdjustedByManager', orderType)}
              label="Pgto. Coop. Alterado"
            />
            <th>Carteira Folha</th>
            <th>Valor do Portal</th>
            <th>Observação</th>
            {isAdmin && <th>Obs. Analista</th>}
            <CenterColumn data-testid="payroll-table-actions-column">Ações</CenterColumn>
          </tr>
        </TableHeader>
        <TableBody>
          {payrolls.map((payroll) => (
            <PayrollTableRow
              onBaixarArquivoClick={downloadFileByType}
              isAdmin={isAdmin}
              key={payroll.id}
              payroll={payroll}
              canShowApdataInfo={canShowApdataInfo}
              onEditClick={onEditClick}
              onTransmitClick={onTransmitClick}
              onEarlyPayment={onEarlyPayment}
            />
          ))}
        </TableBody>
      </Table>
    </TableWrapper>
  );
}

PayrollTable.propTypes = {
  payrolls: PropTypes.arrayOf(PropTypes.shape()),
  onEditClick: PropTypes.func.isRequired,
  onTransmitClick: PropTypes.func.isRequired,
  onEarlyPayment: PropTypes.func.isRequired,
  onChangeOrder: PropTypes.func.isRequired,
  orderBy: PropTypes.shape().isRequired,
  canShowApdataInfo: PropTypes.bool.isRequired,
};

PayrollTable.defaultProps = {
  payrolls: undefined,
};

export default PayrollTable;
